import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Title class.
 */
export default class Shapes extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Shapes',
    refs: ['element'],
  };

  /**
   *
   */
  mounted() {
    this.tween = gsap.to(this.$refs.element, {
      y: -300,
      ease: 'none',
      scrollTrigger: {
        trigger: this.$el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  /**
   *
   */
  destroyed() {
    this.tween?.scrollTrigger?.kill();
    this.tween?.kill();
  }
}
